export class ConnectGoogleWorkspaceResponse {
    'googleWorkspace';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "googleWorkspace",
            "baseName": "googleWorkspace",
            "type": "GoogleWorkspace",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectGoogleWorkspaceResponse.attributeTypeMap;
    }
    constructor() {
    }
}
